import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@fluentui/react';
import { CoherenceTheme } from '@coherence-design-system/styles';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { AuthWrapper } from './auth';
import { store } from './store';
import { NavBar } from './components/NavBar';
import App from './App';

initializeIcons();

const container = document.getElementById('root');
if (!container) throw new Error('#root element not found');
const root = createRoot(container);
root.render(
    <ThemeProvider theme={CoherenceTheme}>
      <FluentProvider theme={webLightTheme}>
        <AuthWrapper>
          <Provider store={store}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
              <NavBar />
              <div style={{ flex: 1, overflow: 'auto' }}>
                <App />
              </div>
            </div>
          </Provider>
        </AuthWrapper>
      </FluentProvider>
    </ThemeProvider>
  );